if(!customElements.get('product-bundle-overview')) {
  class ProductBundleOverview extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    allowDebug() {
      return this.classList.contains('debug');
    }

    init(){
      // console.log(`ProductBundleOverview init()`, this);
      this.bundleId = this.generateBundleId();

      this.bundleTitle = this.dataset.title;

      this.combinedPriceAppend = "FOR COMPLETE LOOK";

      this.itemElements = this.querySelectorAll('product-bundle-item');
      // console.log(this.itemElements);

      this.promotionElements = this.querySelectorAll('product-promotion');
      // console.log(this.promotionElements);

      this.priceElements = this.querySelectorAll('.product__price-text');
      // console.log(this.priceElements);

      this.promotionPricingMessaging = this.querySelectorAll('.product__promotion-pricing-messaging');
      // console.log(this.promotionPricingMessaging);

      this.submitButton = this.querySelector('button[data-add-all-to-cart]');

      this.cartMessage = this.querySelector('.product__bundle__cart-message');

      this.promotion = {};

      this.initEventListeners();

      this.bundleItemVariants = [];

    }

    initEventListeners(){
      this.addEventListener('product-bundle-item:variant-change', this.handleBundleItemVariantChange);
      this.addEventListener('product-promotion:change', this.handlePromotionChange);
      this.submitButton?.addEventListener("click", this.submitBundleATC.bind(this));
    }

    generateBundleId(){
      this.now = new Date();
      return `bundle-${this.id}-${this.now.getTime()}`;
    }

    handleBundleItemVariantChange(event) {
      // Check if the event's triggering element is a descendant of this component
      if (this.contains(event.target)) {
        // Handle the event, knowing it originated from a descendant <product-bundle-item>
        this.allowDebug() && console.log('ProductBundleOverview variant change detected in a child product-bundle-item', event.target);
        this.allowDebug() && console.log('ProductBundleOverview variant', event.detail.variant);
        this.setBundleVariants();
        this.updatePriceElements();
        this.updateBundleATC();
        this.dispatchEvent(new CustomEvent('product-bundle-overview:variant-change', {
          bubbles: true,
          detail: { variants: this.getBundleVariants() }
        }));
      }
    }

    setBundleVariants(){
      if(!this.itemElements) return;
      this.bundleItemVariants = [];
      this.itemElements.forEach((itemElement)=>{
        this.bundleItemVariants.push(itemElement.getVariant());
      });
    }

    getBundleVariants(){
      return this.bundleItemVariants;
    }

    handlePromotionChange(event){
      // Check if the event's triggering element is a descendant of this component
      if (this.contains(event.target)) {
        // Handle the event, knowing it originated from a descendant <product-promotion>
        // console.log('ProductBundleOverview promotion change detected in a child product-bundle-item', event.target);
        this.promotion = event.detail.promotion;
        // console.log('ProductBundleOverview promotion', this.promotion);
        this.updatePriceElements();
      }
    }

    updatePriceElements(){
      // console.log(`ProductBundleOverview updatePriceElements()`);
      if(this.priceElements.length === 0) return;

      /*
        If this.promotion has keys, we have a promotion.
        We want to see if the promotion returned has the property applies_discount && get the property discount type.
        If the discount type is "percent_off" we want to store that value.
        TODO: cover amount_off
      */

      let percentOff = 0;
      if (Object.keys(this.promotion).length > 0) {
        if(this.promotion.fields.applies_discount && this.promotion.fields.hasOwnProperty("percent_off")){
          percentOff = this.promotion.fields.percent_off;
        }
      }

      /*
        Next, we want to loop through this.itemElements, and call their "getVariant()" function. This will return an object with important information.
        We want to add up the "price" property of each one.
        If we have percent off data, we want another variable that is the total itemElements cost with the discount applied.
      */

      let bundleTotal = 0;
      let discountedBundleTotal = 0;
      this.itemElements.forEach((item) => {
        const variant = item.getVariant();
        if (variant && variant.price) {
          bundleTotal += variant.price;
        }
      });

      // console.log(`bundleTotal: ${bundleTotal}`);

      if (percentOff > 0) {
        discountedBundleTotal = (bundleTotal - (bundleTotal * (percentOff / 100)));
        // console.log(`discountedBundleTotal: ${discountedBundleTotal}`);
      }

      // activate pricing messaging
      if(this.promotion?.hasOwnProperty('disclaimer') && this.promotionPricingMessaging){
        this.promotionPricingMessaging.forEach((pricingMessage)=>{
          pricingMessage.innerHTML = this.promotion.fields.disclaimer;
          pricingMessage.classList.remove('hidden');
        });
      }

      const bundleTotalFormatted = Shopify.formatMoney((bundleTotal), '${{amount}}');
      const discountedBundleTotalFormatted = Shopify.formatMoney((discountedBundleTotal), '${{amount}}');

      // Update the price display
      let priceContent = ``;
      if(discountedBundleTotal > 0){
        priceContent = `<span class="strikethrough product__price-light">${bundleTotalFormatted}</span><span>${discountedBundleTotalFormatted}</span><span class="product__price-append">${this.combinedPriceAppend}</span>`;
      } else {
        priceContent = `<span>${bundleTotalFormatted}</span><span class="product__price-append">${this.combinedPriceAppend}</span>`;
      }

      this.priceElements.forEach(priceElement => {
        priceElement.innerHTML = `${priceContent}`;
      });
    }

    updateBundleATC() {
      let allVariantsAvailable = true;

      if(!this.submitButton) return;

      const buttonText = this.submitButton.querySelector('.button__text');

      for (const itemElement of this.itemElements) {
        const currentVariant = itemElement.getVariant();
        if (!currentVariant || currentVariant.available !== true) {
          allVariantsAvailable = false;
          break; // Exit the loop if any variant is not available
        }
      }

      if (allVariantsAvailable) {
        // Enable the submit button if all variants are available
        this.submitButton.classList.remove('disabled');
        this.submitButton.removeAttribute('disabled');
        this.submitButton.removeAttribute('aria-disabled');
        // Reset the button message to indicate the user can add the bundle to the bag
        if (buttonText) {
          buttonText.innerHTML = this.submitButton.dataset.availableText;
        }
        // Reset the cart message to indicate the user should make sure they have the right options selected
        if (this.cartMessage) {
          this.cartMessage.innerHTML = "Please make sure you've selected the correct sizes.";
        }
      } else {
        // Disable the submit button if any variant is not available
        this.submitButton.classList.add('disabled');
        this.submitButton.setAttribute('disabled', 'disabled');
        this.submitButton.setAttribute('aria-disabled', 'true');
        // Update the button message to indicate that not all items are available
        if (buttonText) {
          buttonText.innerHTML = this.submitButton.dataset.unavailableText;
        }
        // Update the cart message to indicate that not all items are available
        if (this.cartMessage) {
          this.cartMessage.innerHTML = "Please select a different combination.";
        }
      }
    }

    async submitBundleATC(event){
      event.preventDefault();
      // if the ATC button is not present on the page, we do not want to allow submission.
      if(!this.submitButton) return;
      // console.log('submitToCart() start');
      try{
        const action = `${window.routes.cart_add_url}.js`;

        // set the ATC button to a loading state.
        if(this.submitButton){
          this.submitButton.classList.add('disabled');
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('loading');
          this.submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        }

        // compile the item data being sent to cart.
        let send_items = [];

        if(this.itemElements.length > 0){
          this.itemElements.forEach((bundleProduct)=>{
            const bundleVariant = bundleProduct.getVariant();
            if(!bundleVariant.available) return;
            let properties = {};
            properties["_gc:bundle-product"] = this.bundleTitle;
            properties["_gc:bundle-ID"] = this.bundleId;
            properties["_gc:bundle-length"] = this.itemElements.length;
            properties["_ord_type"] = bundleProduct.getOrderType();
            if(bundleVariant.hasOwnProperty("final_sale") && bundleVariant.final_sale == true){
              properties["_Final Sale"] = true;
            }
            if(bundleVariant.hasOwnProperty("color")){
              properties["_color_id"] = bundleVariant.color;
            }
            // Collect promotion properties
            if (Object.keys(this.promotion).length > 0) {
              const promotionProperties = ProductPromotions.returnProperties(this.promotion);
              if (Object.keys(promotionProperties).length > 0) {
                // Go through the promotionProperties return and add each property entry to the properties object
                Object.entries(promotionProperties).forEach(([key, value]) => {
                  properties[`${key}`] = value.value;
                });
              }
            }
            if(bundleProduct.form){
              bundleProduct.form.querySelectorAll(`input[type="hidden"][name^="properties["]`).forEach(el => {
                const propertyName = el.name.match(/\[([^)]+)\]/)?.[1];
                if (propertyName) properties[propertyName] = el.value;
              });
            }
            this.querySelectorAll(`.product__bundle__add-all-container input[type="hidden"][name^="properties["]`).forEach(el => {
              const propertyName = el.name.match(/\[([^)]+)\]/)?.[1];
              if (propertyName) properties[propertyName] = el.value;
            });
            send_items.push({
              id: bundleVariant.id,
              quantity: 1,
              properties: properties
            });
          });
        } else {
          // console.log("No bundle product elements. Cancelling ATC.");
          this.bundleId = this.generateBundleId();
          return;
        }

        if(send_items.length != this.itemElements.length){
          /*
            If the amount of items we are sending to cart does NOT match the amount of bundle cards, that means we had unavailable components.
            Bundles are all or nothing, so let's stop this process.
          */
            // console.log("Not all bundle components are available. Exiting ATC.");
            this.bundleId = this.generateBundleId();
            return;
        }

        const requestBody = { items: send_items.reverse() };
        // post to the cart.

        await fetch(action, {
          method: 'POST',
          body: JSON.stringify(requestBody),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          }})
          .then(res => res.json())
          .then((response) => {
            if(!response.hasOwnProperty('items')){
              if(this.cartMessage){
                this.cartMessage.innerHTML = `${response.message} - ${response.description}`;
                this.cartMessage.classList.add('error');
              }

              if(this.submitButton){
                this.submitButton.classList.remove('loading');
                this.submitButton.classList.remove('disabled');
                this.submitButton.removeAttribute('disabled');
                this.submitButton.removeAttribute('aria-disabled');
                this.submitButton.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
              }
              return;
            }
            if(this.cartMessage){
              this.cartMessage.innerHTML = `Please make sure you've selected the correct sizes.`;
              this.cartMessage.classList.remove('error');
            }

            const cartDrawer = document.querySelector('#shopify-section-cart-drawer cart-drawer');
            if(cartDrawer){
              cartDrawer.refresh();
              cartDrawer.open();
            }

            const quickview = this.closest('quickview-modal');
            if(quickview) quickview.close();

            if(this.submitButton){
              this.submitButton.classList.remove('loading');
              this.submitButton.classList.remove('disabled');
              this.submitButton.removeAttribute('disabled');
              this.submitButton.removeAttribute('aria-disabled');
              this.submitButton.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
            }
            this.bundleId = this.generateBundleId();
          })
          .catch(error => console.error(error));
        } catch(error){
          console.error(error);
        }
        // console.log('submitToCart() complete');
    }
  }

  customElements.define('product-bundle-overview', ProductBundleOverview);
}
